const fundiiS3Subject = {
  1: 'portugues',
  2: 'historia',
  3: 'geografia',
  4: 'arte',
  5: 'matematica',
  6: 'ciencias',
  7: 'ingles',
};

const activitiesTypeObject = {
  'múltipla escolha': {
    urlSlug: 'multipla-escolha',
    title: 'Múltipla escolha',
  },
  'atividade aberta': {
    urlSlug: 'atividade-aberta',
    title: 'Atividade aberta',
  },
  'aprendizagem baseada em problemas': {
    urlSlug: 'aprendizagem-baseada-em-problemas',
    title: 'Aprendizagem baseada em problemas',
  },
  'cultura maker': {
    urlSlug: 'cultura-maker',
    title: 'Cultura Maker',
  },
  'aprendizagem baseada em projetos': {
    urlSlug: 'aprendizagem-baseada-em-projetos',
    title: 'Aprendizagem baseada em projetos',
  },
  'sala de aula invertida': {
    urlSlug: 'sala-invertida',
    title: 'Sala invertida',
  },
  'aprendizagem entre pares': {
    urlSlug: 'aprendizagem-entre-pares',
    title: 'Aprendizagem entre pares',
  },
  'design sprint': {
    urlSlug: 'design-sprint',
    title: 'Design Sprint',
  },
  'design thinking': {
    urlSlug: 'design-thinking',
    title: 'Design Thinking',
  },
  'estudo de caso': {
    urlSlug: 'estudo-de-caso',
    title: 'Estudo de Caso',
  },
  'ensino híbrido': {
    urlSlug: 'ensino-hibrido',
    title: 'Ensino Híbrido',
  },
  gamificação: {
    urlSlug: 'gamificacao',
    title: 'Gamificação',
  },
  'modelo de debate crítico (mdc)': {
    urlSlug: 'modelo-de-debate-critico',
    title: 'Modelo de Debate Crítico (MDC)',
  },
  'rotação por estações': {
    urlSlug: 'rotacao-por-estacoes',
    title: 'Rotação por estações',
  },
};

module.exports = {
  fundiiS3Subject,
  activitiesTypeObject,
};
